export default defineNuxtPlugin(() => {
  const moduleOptions = useRuntimeConfig().public.cookieControl;
  const dashboardCustomizationStore = useDashboardCustomization();
  const googleAnalyticsId = dashboardCustomizationStore.googleAnalyticsMeasurementId;
  const clarityProjectId = dashboardCustomizationStore.microsoftClarityProjectId;

  const enabledCookies = useCookie<undefined | string>('cookie_enabled_ids');
  const analyticsCookieConsent = computed(() => {
    if (!enabledCookies.value) return false;
    return moduleOptions.cookies.optional.some(cookie => enabledCookies.value?.includes(cookie.id));
  });

  const trigger = useScriptTriggerConsent({
    consent: analyticsCookieConsent,
  });

  const { proxy: analyticsProxy } = useScriptGoogleAnalytics({
    id: googleAnalyticsId,
    scriptOptions: {
      trigger,
    },
  });

  const { proxy: clarityProxy, load: loadClarity } = useScriptClarity({
    id: clarityProjectId,
    scriptOptions: {
      trigger,
    },
  });

  watch(analyticsCookieConsent, async value => {
    analyticsProxy.gtag('consent', 'update', {
      analytics_storage: value ? 'granted' : 'denied',
      ad_storage: value ? 'granted' : 'denied',
      ad_personalization: value ? 'granted' : 'denied',
      ad_user_data: value ? 'granted' : 'denied',
    });

    if (!value) {
      window.clarity('stop');
      return;
    }

    if (clarityProjectId.length) {
      clarityProxy.clarity('consent');
      await loadClarity();
    }
  });
});
